import { useState } from 'react';
import { AppBar, Toolbar, Box, Button, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { PATHS } from '../../routes';
import CtaFormDialog from '../common/CtaFormDialog';
import { BRAND } from '../../theme/palette';

// Deliberately minimal compared to references/ProdWebsite's LandingPageNav —
// there's no loan-programs/blog/calculators content yet for an MVP skeleton.
export default function Nav() {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <AppBar position="sticky" sx={{ bgcolor: BRAND.navBackground }} elevation={0}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between', py: 1.5 }}>
          <Box
            component={RouterLink}
            to={PATHS.home}
            sx={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
          >
            <Box
              component="img"
              src="/assets/logo-white.svg"
              alt="Cherry Creek Mortgage, LLC"
              sx={{ height: 74, width: 'auto' }}
            />
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              component={RouterLink}
              to={PATHS.home}
              sx={{ color: 'rgba(255,255,255,0.88)', '&:hover': { color: '#fff' } }}
            >
              Home
            </Button>
            <Button
              onClick={() => setContactOpen(true)}
              variant="contained"
              sx={{
                bgcolor: BRAND.ctaGold,
                color: '#1c1e2a',
                fontWeight: 700,
                '&:hover': { bgcolor: BRAND.ctaGoldHover },
              }}
            >
              Contact Us
            </Button>
          </Box>
        </Toolbar>
      </Container>

      <CtaFormDialog open={contactOpen} onClose={() => setContactOpen(false)} title="Contact Us" />
    </AppBar>
  );
}
